(() => {
  'use strict';
  if (window.soilyProductInitialized) return;
  window.soilyProductInitialized = true;

  function initProduct(root) {
    const select = root.querySelector('[data-variant]');
    if (!select || root.dataset.productInitialized) return;
    root.dataset.productInitialized = 'true';
    const choices = [...root.querySelectorAll('[data-bag-choice]')];
    const choiceFieldset = root.querySelector('[data-bag-choices]');
    const fallbackSelect = root.querySelector('[data-select-fallback]');
    if (choices.length && choiceFieldset && fallbackSelect) {
      choiceFieldset.hidden = false;
      fallbackSelect.hidden = true;
      choices.forEach(choice => choice.addEventListener('change', () => {
        select.value = choice.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    }
    const price = root.querySelector('[data-price]');
    const regularPrice = root.querySelector('[data-regular-price]');
    const regularAmount = root.querySelector('[data-regular-amount]');
    const shipping = root.querySelector('[data-product-shipping]');
    const button = root.querySelector('[data-add]');
    const quantity = root.querySelector('[name="quantity"]');
    const availability = root.querySelector('[data-product-availability]');
    const stock = root.querySelector('[data-live-stock]');
    const intro = root.querySelector('[data-product-intro]');
    const form = root.querySelector('.soily-product-form');
    const image = root.querySelector('.product-main-image');
    const fallbackImage = image ? { src: image.src, srcset: image.getAttribute('srcset'), alt: image.alt } : null;

    function update(changeUrl = false) {
      const option = select.selectedOptions[0];
      if (!option) return;
      choices.forEach(choice => { choice.checked = choice.value === option.value; });
      const available = option.dataset.available === 'true';
      const tracked = option.dataset.inventoryTracked === 'true';
      const inventory = Number(option.dataset.inventory);
      if (stock) {
        stock.hidden = !available;
        stock.textContent = tracked && inventory > 0 ? (inventory <= 5 ? root.dataset.labelLowStock : root.dataset.labelStock).replace('__COUNT__', String(inventory)) : root.dataset.labelInStock;
        stock.classList.toggle('is-low', tracked && inventory > 0 && inventory <= 5);
      }
      if (price) price.textContent = option.dataset.price;
      if (regularPrice) regularPrice.hidden = option.dataset.sale !== 'true';
      if (regularAmount) regularAmount.textContent = option.dataset.regularPrice || option.dataset.price;
      if (shipping && option.dataset.shipping) shipping.textContent = option.dataset.shipping;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? root.dataset.labelAdd : root.dataset.labelSoldOut;
      }
      if (availability) {
        availability.hidden = available;
        availability.textContent = root.dataset.productAvailable === 'true' ? root.dataset.labelSizeSoldOut : root.dataset.labelBlendSoldOut;
      }
      const offer = option.dataset.intro === 'true';
      if (intro) intro.hidden = !offer;
      if (form) {
        let returnInput = form.querySelector('[name="return_to"]');
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden'; returnInput.name = 'return_to'; form.append(returnInput);
        }
        returnInput.value = offer ? root.dataset.offerReturn : root.dataset.cartReturn;
      }
      if (quantity) {
        const minimum = Number(option.dataset.min) || 1;
        const increment = Number(option.dataset.step) || 1;
        let maximum = Number(option.dataset.max) || null;
        if (tracked && option.dataset.inventoryPolicy === 'deny') maximum = maximum === null ? inventory : Math.min(maximum, inventory);
        quantity.min = String(minimum); quantity.step = String(increment);
        if (maximum !== null) quantity.max = String(maximum); else quantity.removeAttribute('max');
        if (changeUrl) {
          const current = Number(quantity.value) || minimum;
          let amount = minimum + Math.max(0, Math.ceil((current - minimum) / increment)) * increment;
          if (maximum !== null) amount = Math.min(amount, minimum + Math.max(0, Math.floor((maximum - minimum) / increment)) * increment);
          quantity.value = String(amount);
        }
      }
      if (image && fallbackImage && changeUrl) {
        if (option.dataset.image) {
          image.src = option.dataset.image;
          image.removeAttribute('srcset');
          image.alt = option.dataset.imageAlt || fallbackImage.alt;
        } else {
          image.src = fallbackImage.src;
          if (fallbackImage.srcset) image.setAttribute('srcset', fallbackImage.srcset); else image.removeAttribute('srcset');
          image.alt = fallbackImage.alt;
        }
      }
      if (changeUrl && root.dataset.updateVariantUrl === 'true') {
        const url = new URL(location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState(null, '', url);
      }
    }
    select.addEventListener('change', () => update(true));
    form?.addEventListener('submit', event => {
      update();
      if (select.selectedOptions[0]?.dataset.available !== 'true') event.preventDefault();
    });
    update();
  }

  function initialize(scope) {
    if (scope.matches?.('[data-product]')) initProduct(scope);
    scope.querySelectorAll('[data-product]').forEach(initProduct);
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
